import {AlertIcon} from '@primer/octicons-react'
import {Blankslate, SkeletonText} from '@primer/react/experimental'
import {ForYouItemSkeleton} from './shared/ForYouItemFallbacks'

export function ForYouSectionSkeleton() {
  return (
    <div className="d-flex gap-3 flex-column" aria-busy="true">
      {[0, 1].map(i => (
        <div key={i} className="d-flex flex-column gap-2">
          <SkeletonText size="titleSmall" style={{width: 120}} />
          {/* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */}
          <ul className="List-style-none p-0 m-0 d-flex flex-column gap-2">
            {[0, 1].map(j => (
              <ForYouItemSkeleton key={j} />
            ))}
          </ul>
        </div>
      ))}
    </div>
  )
}

export function ForYouSectionError() {
  return (
    <Blankslate size="small" border>
      <Blankslate.Visual>
        <AlertIcon size="medium" />
      </Blankslate.Visual>
      <Blankslate.Heading as="h3">Unable to load this section</Blankslate.Heading>
      <Blankslate.Description>Try reloading the page.</Blankslate.Description>
    </Blankslate>
  )
}
